import { ProjectTemplateService } from './project-template.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  ProjectTemplatesErroredAction,
  ProjectTemplatesLoadedAction,
  ProjectTemplatesPermissionDeniedAction,
} from './project-template.actions';
import { DashboardOpenedAction } from '../dashboard/dashboard.actions';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { iif, of, defer } from 'rxjs';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppStore } from '../store.model';
import { getHasTemplatesPermission } from '../user/user.selectors';

@Injectable()
export class ProjectTemplateEffects {
  loadTemplates$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DashboardOpenedAction),
      withLatestFrom(this.store.select(getHasTemplatesPermission)),
      switchMap(([, templatesPermission]) =>
        iif(
          () => templatesPermission,
          defer(() =>
            this.projectTemplateService.loadTemplates().pipe(
              map((templates) => ProjectTemplatesLoadedAction({ templates })),
              catchError(() => of(ProjectTemplatesErroredAction())),
            ),
          ),
          of(ProjectTemplatesPermissionDeniedAction()),
        ),
      ),
    ),
  );

  constructor(
    private store: Store<AppStore>,
    protected actions$: Actions,
    protected projectTemplateService: ProjectTemplateService,
  ) {}
}
